import { render, staticRenderFns } from "./harbor-create.vue?vue&type=template&id=656a757a&"
import script from "./harbor-create.vue?vue&type=script&lang=js&"
export * from "./harbor-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports